const noop = () => {};
const resolved = (v) => () => Promise.resolve(v);

const tokenParsed = {
  preferred_username: 'mock.admin',
  name: 'Mock Admin',
  email: 'mock.admin@hia.local',
  realm_access: { roles: ['HIA_ADMIN'] },
  exp: Math.floor(Date.now() / 1000) + 60 * 60,
};

const keycloakStub = {
  authenticated: true,
  token: 'mock-token',
  refreshToken: 'mock-refresh-token',
  tokenParsed,
  refreshTokenParsed: tokenParsed,
  realmAccess: { roles: ['HIA_ADMIN'] },
  resourceAccess: {},
  clientId: 'front-hia-mock',
  subject: 'mock-user-id',
  init: resolved(true),
  login: resolved(),
  logout: () => {
    // eslint-disable-next-line no-console
    console.info('[mock] keycloak.logout() — ignored in mock mode');
  },
  updateToken: resolved(true),
  isTokenExpired: () => false,
  hasRealmRole: (role) => role === 'HIA_ADMIN',
  hasResourceRole: () => false,
  loadUserProfile: resolved({
    username: 'mock.admin',
    firstName: 'Mock',
    lastName: 'Admin',
    email: 'mock.admin@hia.local',
  }),
  loadUserInfo: resolved({ sub: 'mock-user-id', preferred_username: 'mock.admin' }),
  clearToken: noop,
  onAuthSuccess: noop,
  onAuthError: noop,
  onAuthRefreshSuccess: noop,
  onAuthRefreshError: noop,
  onAuthLogout: noop,
  onTokenExpired: noop,
};

export default keycloakStub;
